import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("h3", { class: "fw-bolder" }, "Datos generales", -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "separator mt-5 mb-10" }, null, -1)
const _hoisted_3 = { class: "row mb-7" }
const _hoisted_4 = /*#__PURE__*/_createVNode("label", { class: "col-lg-3 fw-bold text-muted" }, "ID", -1)
const _hoisted_5 = { class: "col-lg-3" }
const _hoisted_6 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_7 = /*#__PURE__*/_createVNode("label", { class: "col-lg-3 fw-bold text-muted" }, "POS ID", -1)
const _hoisted_8 = { class: "col-lg-3" }
const _hoisted_9 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_10 = { class: "row mb-7" }
const _hoisted_11 = /*#__PURE__*/_createVNode("label", { class: "col-lg-3 fw-bold text-muted" }, "Cliente", -1)
const _hoisted_12 = { class: "col-lg-3" }
const _hoisted_13 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_14 = /*#__PURE__*/_createVNode("label", { class: "col-lg-3 fw-bold text-muted" }, "Fecha del pedido", -1)
const _hoisted_15 = { class: "col-lg-3" }
const _hoisted_16 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_17 = { class: "row mb-7" }
const _hoisted_18 = /*#__PURE__*/_createVNode("label", { class: "col-lg-3 fw-bold text-muted" }, "Tipo de orden", -1)
const _hoisted_19 = { class: "col-lg-3" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = /*#__PURE__*/_createVNode("span", { class: "badge badge-light-warning" }, " Recoger en sucursal ", -1)
const _hoisted_22 = { key: 1 }
const _hoisted_23 = /*#__PURE__*/_createVNode("span", { class: "badge badge-light-primary" }, " Servicio a domicilio ", -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("label", { class: "col-lg-3 fw-bold text-muted" }, "Fecha de entrega", -1)
const _hoisted_25 = { class: "col-lg-3" }
const _hoisted_26 = {
  key: 0,
  class: ""
}
const _hoisted_27 = { class: "badge badge-light-warning" }
const _hoisted_28 = {
  key: 1,
  class: ""
}
const _hoisted_29 = /*#__PURE__*/_createVNode("span", { class: "badge badge-light-primary" }, " ASAP ", -1)
const _hoisted_30 = { class: "row mb-7" }
const _hoisted_31 = /*#__PURE__*/_createVNode("label", { class: "col-lg-3 fw-bold text-muted" }, "Sucursal", -1)
const _hoisted_32 = { class: "col-lg-9" }
const _hoisted_33 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_34 = { class: "row mb-7" }
const _hoisted_35 = /*#__PURE__*/_createVNode("label", { class: "col-lg-3 fw-bold text-muted" }, "Dirección de entrega", -1)
const _hoisted_36 = { class: "col-lg-9" }
const _hoisted_37 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_38 = { class: "row mb-7" }
const _hoisted_39 = /*#__PURE__*/_createVNode("label", { class: "col-lg-3 fw-bold text-muted" }, "Comentarios", -1)
const _hoisted_40 = { class: "col-lg-9" }
const _hoisted_41 = {
  class: "fw-bolder fs-6 text-dark",
  style: {"white-space":"pre"}
}
const _hoisted_42 = /*#__PURE__*/_createVNode("h3", { class: "fw-bolder mt-10" }, "Totales", -1)
const _hoisted_43 = /*#__PURE__*/_createVNode("div", { class: "separator mt-5 mb-10" }, null, -1)
const _hoisted_44 = { class: "row mb-7" }
const _hoisted_45 = /*#__PURE__*/_createVNode("label", { class: "col-lg-3 fw-bold text-muted" }, "Subtotal", -1)
const _hoisted_46 = { class: "col-lg-3" }
const _hoisted_47 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_48 = /*#__PURE__*/_createVNode("label", { class: "col-lg-3 fw-bold text-muted" }, "Tipo de pago", -1)
const _hoisted_49 = { class: "col-lg-3" }
const _hoisted_50 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_51 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_52 = /*#__PURE__*/_createVNode("span", { class: "badge badge-light-success" }, " Orden pagada en línea ", -1)
const _hoisted_53 = {
  key: 1,
  class: "mt-2"
}
const _hoisted_54 = /*#__PURE__*/_createVNode("span", { class: "badge badge-light-success" }, " Pago en sucursal ", -1)
const _hoisted_55 = {
  key: 2,
  class: "mt-2"
}
const _hoisted_56 = { class: "badge badge-light-success" }
const _hoisted_57 = { class: "row mb-7" }
const _hoisted_58 = /*#__PURE__*/_createVNode("label", { class: "col-lg-3 fw-bold text-muted" }, "Envío", -1)
const _hoisted_59 = { class: "col-lg-3" }
const _hoisted_60 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_61 = /*#__PURE__*/_createVNode("label", { class: "col-lg-3 fw-bold text-muted" }, "Puntos obtenidos", -1)
const _hoisted_62 = { class: "col-lg-3" }
const _hoisted_63 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_64 = { class: "row mb-7" }
const _hoisted_65 = /*#__PURE__*/_createVNode("label", { class: "col-lg-3 fw-bold text-muted" }, "Descuento", -1)
const _hoisted_66 = { class: "col-lg-3" }
const _hoisted_67 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_68 = /*#__PURE__*/_createVNode("label", { class: "col-lg-3 fw-bold text-muted" }, "Puntos usados", -1)
const _hoisted_69 = { class: "col-lg-3" }
const _hoisted_70 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_71 = { class: "row mb-7" }
const _hoisted_72 = /*#__PURE__*/_createVNode("label", { class: "col-lg-3 fw-bold text-muted" }, "Total", -1)
const _hoisted_73 = { class: "col-lg-9" }
const _hoisted_74 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_75 = /*#__PURE__*/_createVNode("h3", { class: "fw-bolder mt-10" }, "Productos", -1)
const _hoisted_76 = /*#__PURE__*/_createVNode("div", { class: "separator mt-5 mb-10" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OrderProductListItem = _resolveComponent("OrderProductListItem")

  return (_openBlock(), _createBlock("div", null, [
    _hoisted_1,
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode("div", _hoisted_5, [
        _createVNode("span", _hoisted_6, _toDisplayString(_ctx.order?.OrderId), 1)
      ]),
      _hoisted_7,
      _createVNode("div", _hoisted_8, [
        _createVNode("span", _hoisted_9, _toDisplayString(_ctx.order?.OrderCheffId), 1)
      ])
    ]),
    _createVNode("div", _hoisted_10, [
      _hoisted_11,
      _createVNode("div", _hoisted_12, [
        _createVNode("span", _hoisted_13, _toDisplayString(_ctx.order?.ClientName), 1)
      ]),
      _hoisted_14,
      _createVNode("div", _hoisted_15, [
        _createVNode("span", _hoisted_16, _toDisplayString(_ctx.context.formatUtcString(_ctx.order?.OrderStringPlaceDate, 'YYYY/MM/DD HH:mm')), 1)
      ])
    ]),
    _createVNode("div", _hoisted_17, [
      _hoisted_18,
      _createVNode("div", _hoisted_19, [
        (_ctx.order?.OrderIsPickUp)
          ? (_openBlock(), _createBlock("div", _hoisted_20, [
              _hoisted_21
            ]))
          : _createCommentVNode("", true),
        (!_ctx.order?.OrderIsPickUp)
          ? (_openBlock(), _createBlock("div", _hoisted_22, [
              _hoisted_23
            ]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_24,
      _createVNode("div", _hoisted_25, [
        (_ctx.order?.OrderScheduleDate)
          ? (_openBlock(), _createBlock("div", _hoisted_26, [
              _createVNode("span", _hoisted_27, _toDisplayString(_ctx.context.formatUtcString(_ctx.order?.OrderScheduleDate, 'YYYY/MM/DD HH:mm')) + " - " + _toDisplayString(_ctx.context.formatUtcString(_ctx.order?.OrderScheduleEndDate, 'HH:mm')), 1)
            ]))
          : _createCommentVNode("", true),
        (!_ctx.order?.OrderScheduleDate)
          ? (_openBlock(), _createBlock("div", _hoisted_28, [
              _hoisted_29
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode("div", _hoisted_30, [
      _hoisted_31,
      _createVNode("div", _hoisted_32, [
        _createVNode("span", _hoisted_33, _toDisplayString(_ctx.order?.BranchName), 1)
      ])
    ]),
    _withDirectives(_createVNode("div", _hoisted_34, [
      _hoisted_35,
      _createVNode("div", _hoisted_36, [
        _createVNode("span", _hoisted_37, _toDisplayString(_ctx.context.getFullAddress(_ctx.order)), 1)
      ])
    ], 512), [
      [_vShow, !_ctx.order?.OrderIsPickUp]
    ]),
    _createVNode("div", _hoisted_38, [
      _hoisted_39,
      _createVNode("div", _hoisted_40, [
        _createVNode("span", _hoisted_41, _toDisplayString(_ctx.order?.OrderComments), 1)
      ])
    ]),
    _hoisted_42,
    _hoisted_43,
    _createVNode("div", _hoisted_44, [
      _hoisted_45,
      _createVNode("div", _hoisted_46, [
        _createVNode("span", _hoisted_47, "$" + _toDisplayString(_ctx.order?.OrderSubTotal?.toFixed(2)), 1)
      ]),
      _hoisted_48,
      _createVNode("div", _hoisted_49, [
        _createVNode("span", _hoisted_50, [
          (_ctx.order?.OrderPayId)
            ? (_openBlock(), _createBlock("div", _hoisted_51, [
                _hoisted_52
              ]))
            : _createCommentVNode("", true),
          (_ctx.order?.OrderIsPickUp && !_ctx.order?.OrderPayId)
            ? (_openBlock(), _createBlock("div", _hoisted_53, [
                _hoisted_54
              ]))
            : _createCommentVNode("", true),
          (!_ctx.order?.OrderIsPickUp && !_ctx.order?.OrderPayId)
            ? (_openBlock(), _createBlock("div", _hoisted_55, [
                _createVNode("span", _hoisted_56, _toDisplayString(_ctx.order?.PaymentType?.PaymentTypeName), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_57, [
      _hoisted_58,
      _createVNode("div", _hoisted_59, [
        _createVNode("span", _hoisted_60, "$" + _toDisplayString(_ctx.order?.OrderChargeFee?.toFixed(2)), 1)
      ]),
      _hoisted_61,
      _createVNode("div", _hoisted_62, [
        _createVNode("span", _hoisted_63, _toDisplayString(_ctx.order?.OrderEarnedPoints), 1)
      ])
    ]),
    _createVNode("div", _hoisted_64, [
      _hoisted_65,
      _createVNode("div", _hoisted_66, [
        _createVNode("span", _hoisted_67, "$" + _toDisplayString(_ctx.order?.OrderDiscount?.toFixed(2)), 1)
      ]),
      _hoisted_68,
      _createVNode("div", _hoisted_69, [
        _createVNode("span", _hoisted_70, _toDisplayString(_ctx.order?.OrderUsedPoints), 1)
      ])
    ]),
    _createVNode("div", _hoisted_71, [
      _hoisted_72,
      _createVNode("div", _hoisted_73, [
        _createVNode("span", _hoisted_74, "$" + _toDisplayString(_ctx.order?.OrderTotal?.toFixed(2)), 1)
      ])
    ]),
    _hoisted_75,
    _hoisted_76,
    _createVNode("div", null, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.order?.ProductList, (orderProduct, index) => {
        return (_openBlock(), _createBlock(_component_OrderProductListItem, {
          key: `${_ctx.order?.OrderId ?? 0}_${index}`,
          product: orderProduct
        }, null, 8, ["product"]))
      }), 128))
    ])
  ]))
}